// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { updateBulkEditState } from 'redux/modules/bulkEdit'

// Toggles the highlight of a single site on a path.

const toggleSiteHighlight = segmentEndId => (dispatch, getState) => {
  const prevHighlighted = getState().bulkEdit.get('highlightedSiteIds')

  // look for the index of this segmentEndId in the current list of highlightedPaths
  const indexInSelectedSites = prevHighlighted.indexOf(segmentEndId)

  // if the segmentEndId wasn't in the list, then add it
  // otherwise remove the thing
  const highlightedSiteIds = (
    !~indexInSelectedSites
      ? prevHighlighted.push(segmentEndId)
      : prevHighlighted.delete(indexInSelectedSites)
  )

  dispatch(updateBulkEditState({ highlightedSiteIds }))
}

export default toggleSiteHighlight
